import { render, staticRenderFns } from "./IconSort.vue?vue&type=template&id=a27199a6&"
import script from "./IconSort.vue?vue&type=script&lang=js&"
export * from "./IconSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports